import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IconCircleCheck } from "@tabler/icons-react";
import { DocumentDtoTypeEnum } from "../../../../../../api";
import { AppRoutes } from "../../../../../../common/routes/app_routes";
import { Button } from "../../../../../../components/common/button";
import { FileUploadItem } from "../../../../../../components/common/file-upload-item";
import { Heading, Text } from "../../../../../../components/common/typography";
import { useDocuments } from "../../../../../settings/hooks/useDocuments";
import { useLogout } from "../../../../hooks/useLogout";
import AuthSplitLayout from "../../../../routes/auth-split-layout";
import { useRegisterWizard } from "../../../../domain/register-wizard";
import { useMePartner } from "../../../../../../swr";

export function ApprovalPendingStep() {
  const navigate = useNavigate();
  const logout = useLogout();
  const wizard = useRegisterWizard();
  const { data } = useDocuments();
  const { isSeller } = useMePartner();
  const continueLabel = isSeller ? "Go to dashboard" : "Back to Procurtal Search";
  const continueRoute = isSeller ? AppRoutes.DASHBOARD : AppRoutes.INDEX;

  const docs = data?.data ?? [];

  // Once the user leaves this screen, clear the wizard so a fresh signup starts over.
  useEffect(() => {
    return () => wizard.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthSplitLayout>
      <div className="flex w-full flex-col items-center gap-6 text-center">
        <span className="inline-flex size-16 items-center justify-center text-accentGreen">
          <IconCircleCheck size={64} />
        </span>
        <Heading variant="h2" tone="dark">
          Documents submitted
        </Heading>
        <Text variant="body" tone="body">
          Our team is reviewing your documents — usually 1–2 business days. In
          the meantime, start browsing and fill your cart. It'll be waiting
          when you're approved.
        </Text>
      </div>

      {docs.map((doc) => (
        <FileUploadItem
          key={doc.id}
          status="uploaded"
          title={
            doc.type === DocumentDtoTypeEnum.Cr
              ? "Commercial Registration"
              : doc.type === DocumentDtoTypeEnum.TaxCard
                ? "Tax Card"
                : undefined
          }
          fileName={doc.fileName || "-"}
          fileSize={doc.fileSize ?? undefined}
        />
      ))}

      <Button
        variant="primary"
        fullWidth
        onClick={() => {
          wizard.reset();
          navigate(continueRoute);
        }}
      >
        {continueLabel}
      </Button>
      <Button
        variant="secondaryLanding"
        fullWidth
        onClick={() => {
          wizard.reset();
          logout();
        }}
      >
        Log out
      </Button>
    </AuthSplitLayout>
  );
}

export default ApprovalPendingStep;
